module.exports = __webpack_public_path__ + "img/Plan Banner.e71e30e8.jpg";